import React from "react";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { startwork } from "./constdata";

const Startwork = ({ data, onSave }) => {
  const onSelect = (value) => {
    onSave("startwork", value);
  };

  return (
    <>
      <section className="startWorkSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading">
                <h4>3. How Soon Do You Need A Developer To Start Work?</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormControl component="fieldset" className="expRadio">
                <RadioGroup
                  aria-label="experience"
                  defaultValue="as_soon_as_possible"
                  name="radio-buttons-group"
                  onChange={(e) => onSelect(e.target.value)}
                  value={data}
                >
                  {startwork.map((s) => (
                    <FormControlLabel
                      value={s.value}
                      className="radioLabel"
                      control={<Radio />}
                      label={s.label}
                      key={s.value}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Startwork;
